// @flow

import React, { Fragment } from 'react'
import styled from 'styled-components'
import Colors from 'components/styles/colors'
import { fontSize } from 'frontend_core/dist/styles/variables'
import Icon from 'components/atoms/Icon'

const ErrorText = styled.p`
  color: ${Colors.red};
  font-size: ${fontSize.small_2}px;
  line-height: 1.3;
`

const SuccessText = styled.p`
  color: ${Colors.black};
  font-size: ${fontSize.small_2}px;
  line-height: 1.3;
`

type PropTypes = {
  errorText?: string,
  successText?: string,
}

export default (props: PropTypes) => {
  const { errorText, successText } = props

  return (
    <Fragment>
      {errorText && (
        <ErrorText>
          <Icon className="fa fa-exclamation-circle" positionType="left" />
          {errorText}
        </ErrorText>
      )}
      {successText && (
        <SuccessText>
          <Icon
            className="fa fa-check-circle"
            positionType="left"
            color={`${Colors.green}`}
          />
          {successText}
        </SuccessText>
      )}
    </Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/atoms/Message/index.jsx